<template>

<iframe height="300" style="width: 100%;" scrolling="no" title="Magic Wand Reveal" src="https://codepen.io/Farah-Kamal/embed/zYeXWbJ?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
  See the Pen <a href="https://codepen.io/Farah-Kamal/pen/zYeXWbJ">
  Magic Wand Reveal</a> by Farah Kamal (<a href="https://codepen.io/Farah-Kamal">@Farah-Kamal</a>)
  on <a href="https://codepen.io">CodePen</a>.
</iframe>

<p>Title: 🌈✨ TrailblazerTabby's Purr-fect Guide to Goal Setting - No Magic Needed! ✨🌈

Introduction:
Hello, Riskypaws pals! 🐾 I'm TrailblazerTabby, your whiskered wizard of wisdom (minus the actual wizardry, of course!). Let's talk about setting goals – and no, we can't just swish a magic stick to make them happen. It's about smart planning and a sprinkle of cat-like cunning. Are you ready to jump onto the goal-setting windowsill with me? Let's leap!

Body:

Set Paws-ible Goals:

Tabby's Tip: Choose goals that make you purr with excitement but are as achievable as catching a lazy sunbeam on a Sunday afternoon.
Learn with Curiosity:

Curious Cat's Wisdom: I didn’t become a finance feline overnight! Devour knowledge like it's your favorite catnip-infused treat.
Map Your Adventure:

Whisker-Wise Planning: Create a treasure map of your financial journey. Every small step is a paw print towards success.
Pounce with Integrity:

Tabby's Truth: Always land on your feet with honest and ethical financial moves. Integrity is the cat's meow!
Stay Alert to the Rules:

Savvy Cat's Guide: Keep your whiskers twitching for new regulations and financial shifts. Staying informed keeps you nimble.
Dream for the Long Haul:

Future Gazing: Think about the long-term paradise of purrs. Patience is a virtue, especially when waiting for the perfect moment to pounce.
Embrace Every Cat and Kitten:

Inclusive Purring: All cats are welcome in the world of finance. Diversity is not only beautiful – it’s smart!
Hard Work and Cat Naps:

Tabby’s Reality Check: Goals aren't just dreamt up in catnaps. They're achieved through persistence, planning, and the occasional well-deserved rest.
Conclusion:
So, my fabulous feline friends and human companions, remember that achieving goals is a journey filled with learning, patience, and smart choices. Follow my purr-fect steps, and soon you'll be leaping to heights you never imagined – all with the grace and wisdom of a financially savvy cat! 🐱💖

Closing Quote:
"In the grand adventure of life, be the cat who's not only curious but clever and courageous. Set those goals, plan with precision, and leap with confidence!" 🌟🐈‍⬛💼</p>
  <div class="scores-container">
    <div class="risk-score-card">
        <i class="fa fa-chart-pie risk-icon"></i>Financial Goals</div>

    <div class="add-button-container">
      <button @click="addNewBudgetItem" class="add-budget-btn">Add New Goal</button>
    </div>

    
    <div class="budget-cards">
      <div v-for="(item, index) in budgetItems" :key="index" class="budget-card">
        <div class="card-header">
          <button class="edit-btn" @click="toggleEditMode(index)">
            <i :class="item.isEditing ? 'fas fa-save' : 'fas fa-edit'"></i>
          </button>
        </div>

        <!-- iPod Screen for Display -->
        <div v-if="!item.isEditing" class="ipod-screen">
          <div class="screen-content">
            <h3> {{ item.name }}</h3>
            <p> {{ item.subcategory }}</p>
            <p>Goal Date: {{ item.savedDate }}</p>
           
          </div>
        </div>

        <!-- Editable Fields -->
        <div v-if="item.isEditing">
          <select v-model="item.category">
            <option value="Travel">Travel</option>
            <option value="Taxes">Taxes</option>
            <option value="Family, Pets & Relationships">Family, Pets & Relationships</option>
            <option value="Income & Savings">Income & Savings</option>
            <option value="Financial Expenses & Insurance">Financial Expenses & Insurance</option>
            <option value="Shopping & Apparel">Shopping & Apparel</option>
            <option value="Entertainment & Hobbies">Entertainment & Hobbies</option>
            <option value="Health & Wellness">Health & Wellness</option>
            <option value="Food & Dining">Food & Dining</option>
            <option value="Auto & Transportation">Auto & Transportation</option>
            <option value="Home & Utilities">Home & Utilities</option>
          </select>
          <input type="text" v-model="item.name" placeholder="Budget Name" />
          <input type="number" v-model.number="item.goalAmount" placeholder="Goal Amount" />
          <input type="number" v-model.number="item.savedAmount" placeholder="Saved Amount" />
          <input type="date" v-model="item.savedDate" placeholder="Saved Date" />
        </div>

        <div class="progress-info">
          <span>Saved: ${{ item.savedAmount }}</span>
          <span>Goal: ${{ item.goalAmount }}</span>
        </div>

        <div class="circular-slider">
          <svg viewBox="0 0 36 36" class="circular-chart">
            <path class="circle-bg"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path class="circle"
              :stroke-dasharray="progress(item) + ', 100'"
              d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <div class="icon-selector">
            <i :class="getIcon(item.category)"></i>
          </div>
</div>


        </div>
      </div></div>
  
  <br><br><br><br><br><br>
</template>
<script setup>
import { ref } from 'vue';


const budgetItems = ref(JSON.parse(localStorage.getItem('budgetItems')) || []);


const toggleEditMode = (index) => {
  budgetItems.value[index].isEditing = !budgetItems.value[index].isEditing;
  localStorage.setItem('budgetItems', JSON.stringify(budgetItems.value));
};
const progress = (item) => {
  return item.goalAmount > 0 ? (item.savedAmount / item.goalAmount) * 100 : 0;
};

const addNewBudgetItem = () => {
  budgetItems.value.push({ name: '', goalAmount: 0, savedAmount: 0, savedDate: '', category: '', subcategory: '', isEditing: false });
  localStorage.setItem('budgetItems', JSON.stringify(budgetItems.value));
};



const getIcon = (category) => {
  switch (category) {
    case 'Travel': return 'fas fa-plane';
    case 'Taxes': return 'fas fa-funnel-dollar';
    case 'Family, Pets & Relationships': return 'fas fa-users';
    case 'Income & Savings': return 'fas fa-wallet';
    case 'Financial Expenses & Insurance': return 'fas fa-hand-holding-usd';
    case 'Shopping & Apparel': return 'fas fa-shopping-bag';
    case 'Entertainment & Hobbies': return 'fas fa-film';
    case 'Health & Wellness': return 'fas fa-heartbeat';
    case 'Food & Dining': return 'fas fa-utensils';
    case 'Auto & Transportation': return 'fas fa-car';
    case 'Home & Utilities': return 'fas fa-home';
    default: return '';
  }
};
</script>



  <style scoped>


.budget-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center; /* Centering the cards */
}

.budget-card {
  background-color: #ffffff; /* White background */
  border: 2px solid #4A148C; /* Dark purple border */
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  width: 220px; /* Adjusted width */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transition for hover effect */
}


input, select {
  width: 100%;
  margin-bottom: 12px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9; /* Light grey background */
  color: #333; /* Dark text for better readability */
}

input:focus, select:focus {
  border-color: #4A148C; /* Dark purple focus */
  outline: none;
}
.risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #4A148C;
  }
  
  .risk-icon {
  margin-right: 10px;
  font-size: 30px;
  }
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #333;
}

.circular-slider {
  position: relative;
  margin-bottom: 10px; /* Added space below the slider */
}

.circular-chart {
  display: block;
  margin: auto;
  max-width: 150px; /* Smaller chart for better fit */
  max-height: 150px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  stroke: #4A148C; /* Dark purple stroke for progress */
}

.icon-selector {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px; /* Slightly larger icon size */
  color: #4A148C; /* Dark purple icon */
}

i {
  pointer-events: none;
}

.add-button-container {
  text-align: center;
  margin-bottom: 20px;
}

.add-budget-btn {
  padding: 10px 20px;
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 20px; /* Rounded corners */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

.add-budget-btn:hover {
  background-color: black; /* Black background on hover */
}

.financial-dashboard {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.net-worth {
  text-align: center;
  margin-bottom: 2rem;
  padding: 1rem;
  background: #4c3575;
  color: #fff;
  border-radius: 8px;
}

.net-worth select {
  padding: 8px;
  margin-left: 10px;
  border-radius: 4px;
  border: 1px solid #4A148C; /* Dark purple border */
  background-color: #f7f7f7;
}

.card-header {
  display: flex;
  justify-content: flex-end;
}

.edit-btn {
  background: none;
  border: none;
  cursor: pointer;
}

.edit-btn i {
  font-size: 16px;
  color: #4A148C; /* Dark purple */
}
.ipod-screen {
  width: 200px; /* Set a fixed width */
  height: 120px; /* Set a fixed height */
  margin: 0 auto; /* Center it horizontally */
  background-color: #f2f2f2; /* Light grey background */
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screen-content {
  text-align: center;
}

.screen-content p {
  margin: 5px 0;
  color: #333;
  font-size: 14px;
}

.storybook-icon {
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  /* additional styling */
}

.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 500px;
  text-align: left;
}

.close {
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.scores-container {
    display: flex;
    flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
    justify-content: center; /* Centers items */
    align-items: center;
    width: 100%;
    border: 2px solid #000;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: white; 
  }
</style>